"use client"
import { Minus, Plus } from "@phosphor-icons/react"

export function EditNumberStepper({id,value,min=0,max=999,onValueChange}:{
  id?:string; value:number; min?:number; max?:number; onValueChange:(value:number)=>void
}) {
  const change=(v:number)=>onValueChange(Math.min(max,Math.max(min,Math.trunc(v))))
  return <div className="edit-number-stepper">
    <button type="button" aria-label="减少数值" disabled={value<=min} onClick={()=>change(value-1)}><Minus size={16}/></button>
    <input id={id} aria-label={id ? undefined : "次数"} type="number" inputMode="numeric" min={min} max={max} value={value} onChange={e=>change(Number(e.target.value)||min)}/>
    <button type="button" aria-label="增加数值" disabled={value>=max} onClick={()=>change(value+1)}><Plus size={16}/></button>
  </div>
}
